import { useEffect, useState } from "react";
import "../styles/tokens.css";
import "../styles/pupil.css";
import { App as MoonPhasesDemo } from "../App";
import { HorizonApp } from "../demos/horizon/HorizonApp";
import { SeasonsApp } from "../demos/seasons/SeasonsApp";
import { Home } from "./Home";
import { applySeoMetadata } from "./seo";

function useHashRoute(): string {
  const [route, setRoute] = useState(() => window.location.hash);

  useEffect(() => {
    const onHashChange = () => {
      setRoute(window.location.hash);
      window.scrollTo(0, 0);
    };
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  return route;
}

export function PupilApp() {
  const route = useHashRoute();

  useEffect(() => {
    applySeoMetadata(route);
  }, [route]);

  // Keying by the full route (including its query) means a pasted lesson
  // link applies even while that demo is already open: React remounts it and
  // the mount-time readers pick the new params up.
  if (route.startsWith("#/demos/moon-phases")) {
    return <MoonPhasesDemo key={route} />;
  }

  if (route.startsWith("#/demos/earth-seasons")) {
    return <SeasonsApp key={route} />;
  }

  if (route.startsWith("#/demos/local-horizon")) {
    return <HorizonApp key={route} />;
  }

  return <Home />;
}
